interface AppConfig {
  apiUrl: string;
  captchaKey: string;
  gtmId: string;
  paddlePaymentId: string;
  paddlePaymentEnv: string;
  googleClientId: string;
}

const config: AppConfig = {
  apiUrl: process.env.REACT_APP_API_URL!,
  captchaKey: process.env.REACT_APP_RECAPTCHA_KEY!,
  gtmId: process.env.REACT_APP_GTM_ID!,
  paddlePaymentId: process.env.REACT_APP_PADDLE_PAYMENT_ID!,
  paddlePaymentEnv: process.env.REACT_APP_PADDLE_PAYMENT_ENV!,
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID!
};

export default config;
